import { Button } from "antd";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import styles from "./ForgotPassword.module.css";
import logo from "../../../assets/images/logo.png";
import {
  Dropdown,
  InputField,
  SubmitButton,
  TextComponent,
} from "../../../components";
import { LuEye, LuEyeOff } from "react-icons/lu";
import { IoChevronBackOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { validateForm } from "../../../utills/Validators";
import { AuthMiddleware } from "../../../Store/Middlewares/AuthMiddleware";
import { showAlert } from "../../../Store/Actions/GeneralActions";
import SubHeadingComponent from "../../../components/SubHeadingComponent/SubHeadingComponent";
function ForgetPassword() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [role, setRole] = useState({ value: "Dealership", id: 1 });

  const formState = [{ key: "Email", value: email }];

  return (
    <div className={styles.mainCont}>
      <div className={styles.leftCont}>
        <img src={logo} className={styles.logoImg} />
      </div>
      <div className={styles.rightCont}>
        <div className={styles.rightWidthCont}>
          <div className={styles.backDiv} onClick={() => navigate("/")}>
            <IoChevronBackOutline color="var(--white-color)" />
            <TextComponent
              className={styles.White_text}
              text={"Back to login"}
            />
          </div>
          <div className={styles.textDiv}>
            <SubHeadingComponent
              text={"Forgot Password?"}
              color={"var(--white-color)"}
            />
            <TextComponent className={styles.welcomeHeading} />
            <TextComponent
              className={styles.Text}
              color="var(--white-color)"
              padding={"0px"}
              text={
                "Please enter your email for us to send confirmation regarding your password change."
              }
            />
          </div>
          <div className={styles.inputDiv}>
            <InputField
              className={styles.input}
              labelClass={styles.White_text}
              label={"Email Address"}
              placeholder={"chris@email.com"}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            {/* <Dropdown
              className={styles.input}
              label={"Role"}
              labelClass={styles.White_text}
              value={role}
              labelStyle={{ color: "#838383", fontSize: 18 }}
              style={{ color: "black" }}
              options={[
                {
                  value: "Dealership",
                  id: 1,
                },
                {
                  value: "Customer",
                  id: 2,
                },
              ]}
              onChange={(e) => setRole(e)}
            /> */}
          </div>
          <div className={styles.btn} onClick={() => navigate("/verifyCode")}>
            <SubmitButton
              title={"Get Code"}
              primary
              btnContainerClass={styles.btnContainer}
              btnClass={`${styles.btnClass}`}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ForgetPassword;
